import styles from "./styles/faq-items.module.scss";
import { FaqItemData } from "@/data/faq.data";
import FaqItem from "@/components/common/faq-item";
import AmplitudeCaptureEventWrapper from "@/providers/amplitude-provider/amplitude-capture-event";

interface FaqItemsProps {
  faqData: FaqItemData[];
}

const FaqItems = ({ faqData }: FaqItemsProps) => {
  return (
    <div className={styles.faq_wrapper}>
      <h1>
        FAQ
      </h1>
      <div className={styles.faq_items_wrapper}>
        {faqData.map((data) => (
          <FaqItem key={data.question} data={data} />
        ))}
      </div>
    </div>
  );
};

export default FaqItems;
